import { type Context, useContext } from 'react';

export const useContextSafely = <T>(context: Context<T>) => {
  const ctx = useContext(context);
  if (!ctx) {
    throw new Error(`Context not defined: ${context.displayName}`);
  }
  return ctx;
};
